<template>
  <filter-table
    primary-key="id"
    empty-text="No Documents added."
    :fields="fields"
    :items="files"
    :slots="templates"
    :show-filter="false"
  >
    <template slot="hint">
      <div class="upload-area">
        <upload-multiple-files
          v-if="checkPermission"
          :url-upload="uploadUrl"
          @success="onSuccessUpload"
          :show-input="true"
          :auto-send="false"
          :params="uploadParams"
        />
      </div>
    </template>
    <template slot="name" slot-scope="record">
      <a :href="record.row.item.link" target="_blank" class="no-text-decoration">
        {{ record.value }}
      </a>
    </template>
    <template slot="submitted" slot-scope="record">
      {{record.value | date}}
    </template>
  </filter-table>
</template>

<script>
import TitleCard from '@/components/utils/TitleCard';
import DocumentsLegend from '@/components/utils/DocumentsLegend';
import FilterTable from '@/components/utils/FilterTable';
import UploadMultipleFiles from '@/components/utils/upload/UploadMultipleFiles';
import SentFilesModal from '@/components/documents/SentFilesModal';
import { ENTITY_WRITE } from '@/libs/permissions_list';
import { string } from 'i/lib/util';

export default {
  name: 'GenericEntityUploadDocuments',
  components: {
    DocumentsLegend,
    TitleCard,
    FilterTable,
    UploadMultipleFiles,
    SentFilesModal,
  },
  props: {
    files: Array,
    uploadUrl: string,
  },
  data() {
    return {
      modalRecord: {},
      uploadParams: { type: 'Salesforce' },
      showUploadModal: false,
      modalNoCloseOnBackdrop: false,
      modalNoCloseOnEsc: false,
      modalHideHeaderClose: false,
      documents: [],
      timeBeforeReload: 6000,
      maxCalls: 6,
      fields: [
        { key: 'name', sortable: true },
        { key: 'submitted', sortable: true },
      ],
      templates: [
        { key: 'name' },
        { key: 'submitted' },
      ],
    };
  },
  computed: {
    checkPermission() {
      return this.$permissions.checkPermissions([ENTITY_WRITE]);
    },
  },
  methods: {
    mounted() {
      this.documents = this.entity.docs.files;
    },
    onSuccessUpload() {
      this.$notify({
        group: 'alert',
        text: 'Uploaded successfully',
      });
      this.$emit('upload-success');
    },
  },
};
</script>

<style scoped>
.upload-area{
  width: 100%;
  margin-right: 18px;
  margin-left: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/entities/documents/GenericEntityUploadDocuments.vue